// extracted by mini-css-extract-plugin
export var actions = "_gv-g";
export var benefitCard = "_gv-b";
export var benefitIcon = "_gv-d";
export var benefitLabel = "_gv-f";
export var benefits = "_gv-a";
export var benefitsSection = "_gv-8";
export var bodyText = "_gv-7";
export var closeButton = "_gv-2";
export var content = "_gv-3";
export var eyebrow = "_gv-4";
export var heading = "_gv-5";
export var image = "_gv-i";
export var imagePanel = "_gv-h";
export var modal = "_gv-0";
export var offerCard = "_gv-c";
export var offerIcon = "_gv-e";
export var sectionLabel = "_gv-9";
export var shell = "_gv-1";
export var title = "_gv-6";